import { createReducer, on } from '@ngrx/store';
// Interfaces / Types / Enums
import { CustomPDFReportDesignation } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-designation.enum';
// NgRx actions
import { setComplianceReportHistoryStore } from '../compliance-report-data/compliance-report-data.actions';
import { setComplianceReportHistoryFilters } from '../filters/filters.actions';
import { setComplianceDesignationTypeOption } from './compliance-designation-type.actions';
export const INITIAL_COMPLIANCE_DESIGNATION_TYPE_FILTER_STATE = {
    [CustomPDFReportDesignation.DELIVERABLE]: true,
    [CustomPDFReportDesignation.DRAFT]: true,
};
export const complianceDesignationType = createReducer(INITIAL_COMPLIANCE_DESIGNATION_TYPE_FILTER_STATE, on(setComplianceDesignationTypeOption, (state, action) => {
    // Create new state with the appropriate reportDesignationOption selected/deselected to match the action
    const newState = { ...state };
    const key = action.designationTypeOption.value;
    newState[key] = action.designationTypeOption.checked;
    return newState;
}), on(setComplianceReportHistoryFilters, (state, action) => {
    return { ...action.designationType };
}), on(setComplianceReportHistoryStore, (state, action) => {
    return { ...action.designationType };
}));
